import API_URL from '../config/api';

// Helper function to get auth token
const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Helper function to make authenticated requests
const authFetch = async (endpoint, options = {}) => {
  const token = getAuthToken();

  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  if (token) {
    defaultHeaders['Authorization'] = `Bearer ${token}`;
  }

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  const response = await fetch(`${API_URL}${endpoint}`, config);

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.message || 'Something went wrong');
  }

  return response.json();
};

// ================= AUTH API =================
export const authAPI = {
  login: async (username, password) => {
    return authFetch('/api/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
  },

  register: async (userData) => {
    return authFetch('/api/auth/register', {
      method: 'POST',
      body: JSON.stringify(userData),
    });
  },

  forgotPassword: async (email) => {
    return authFetch('/api/auth/forgot-password', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  },

  resetPassword: async (token, newPassword) => {
    return authFetch('/api/auth/reset-password', {
      method: 'POST',
      body: JSON.stringify({ token, newPassword }),
    });
  },

  getProfile: async () => {
    return authFetch('/api/user/profile');
  },

  changePassword: async (currentPassword, newPassword) => {
    return authFetch('/api/user/change-password', {
      method: 'POST',
      body: JSON.stringify({ currentPassword, newPassword }),
    });
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  },
};

// ================= USER API =================
export const userAPI = {
  getAllUsers: async () => {
    return authFetch('/api/users');
  },

  getMyUsers: async () => {
    return authFetch('/api/users/my-users');
  },

  addUser: async (userData) => {
    return authFetch('/api/users/add', {
      method: 'POST',
      body: JSON.stringify(userData),
    });
  },

  updateUser: async (id, userData) => {
    return authFetch(`/api/users/${id}`, {
      method: 'PUT',
      body: JSON.stringify(userData),
    });
  },

  deleteUser: async (id) => {
    return authFetch(`/api/users/${id}`, {
      method: 'DELETE',
    });
  },

  toggleUserActive: async (id) => {
    return authFetch(`/api/users/${id}/toggle-active`, {
      method: 'PATCH',
    });
  },
};

// ================= WALLET API =================
export const walletAPI = {
  fundSelf: async (amount) => {
    return authFetch('/api/wallet/fund-self', {
      method: 'POST',
      body: JSON.stringify({ amount }),
    });
  },

  fundReseller: async (reseller_username, amount) => {
    return authFetch('/api/wallet/fund-reseller', {
      method: 'POST',
      body: JSON.stringify({ reseller_username, amount }),
    });
  },
};

// ================= RESELLER API =================
export const resellerAPI = {
  getAll: async () => {
    return authFetch('/api/resellers');
  },

  add: async (resellerData) => {
    return authFetch('/api/resellers/add', {
      method: 'POST',
      body: JSON.stringify(resellerData),
    });
  },
};

// ================= PACKAGE API =================
export const packageAPI = {
  getAll: async () => {
    return authFetch('/api/packages');
  },
};

// ================= TRANSACTION API =================
export const transactionAPI = {
  getAll: async () => {
    return authFetch('/api/transactions');
  },
};

export default authFetch;